module.exports = __webpack_public_path__ + "static/scale-model-of-greenleaf-jacobs-clock-in-jacksonville-florida-512c5df4401934670fc76c69494f6ff3.png";